export default class Location {
  id;
  name;
  address;
  city;
  state;
  zipcode;
  geoPoint;
  photoURL;
  serviceCharge;
  acceptingOrders;
  fulfillmentDelivery;
  fulfillmentPickup;
  pickupInstructions;

  constructor(
    id,
    name,
    address,
    city,
    state,
    zipcode,
    geoPoint,
    photoURL,
    serviceCharge,
    acceptingOrders,
    fulfillmentDelivery,
    fulfillmentPickup,
    pickupInstructions
  ) {
    this.id = id;
    this.name = name;
    this.address = address;
    this.city = city;
    this.state = state;
    this.zipcode = zipcode;
    this.geoPoint = geoPoint;
    this.photoURL = photoURL;
    this.serviceCharge = serviceCharge;
    this.acceptingOrders = acceptingOrders;
    this.fulfillmentDelivery = fulfillmentDelivery;
    this.fulfillmentPickup = fulfillmentPickup;
    this.pickupInstructions = pickupInstructions;
  }

  hasMultipleFulfillments() {
    return Boolean(this.fulfillmentDelivery) && Boolean(this.fulfillmentPickup);
  }

  static firebaseConverter = {
    fromFirestore(snapshot, options) {
      let id = snapshot.id;
      const data = { id, ...snapshot.data(options) };

      if (typeof data.fulfillmentDelivery === "undefined") {
        data.fulfillmentDelivery = true;
      }

      return new Location(
        data.id,
        data.name,
        data.address,
        data.city,
        data.state,
        data.zipcode,
        data.geoPoint,
        data.photoURL,
        data.serviceCharge,
        Boolean(data.acceptingOrders),
        Boolean(data.fulfillmentDelivery),
        Boolean(data.fulfillmentPickup),
        data.pickupInstructions
      );
    },

    toFirestore(location) {
      let {
        id,
        name,
        address,
        city,
        state,
        zipcode,
        geoPoint,
        photoURL,
        serviceCharge,
        acceptingOrders,
        fulfillmentDelivery,
        fulfillmentPickup,
        pickupInstructions
      } = location;
      return {
        id,
        name,
        address,
        city,
        state,
        zipcode,
        geoPoint,
        photoURL,
        serviceCharge,
        acceptingOrders,
        fulfillmentDelivery,
        fulfillmentPickup,
        pickupInstructions
      };
    }
  };
}
